/*
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2026 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 */

import React from 'react';
import PropTypes from 'prop-types';
import { Box, Typography } from '@mui/material';
import UserAvatar from './UserAvatar';
import { AIADMIN_PRIMARY_COLOR, AIADMIN_TEXT_SECONDARY } from '../../common/styles/aiadminThemeTokens';

/** The admin's own message, on the right, with their initials (as in the header) beside it. */
const UserMessage = ({ text }) => (
  <Box sx={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'flex-end', gap: 1.25, mb: 1.5 }}>
    <Typography
      variant="body2"
      sx={{
        px: 1.5,
        py: 1,
        maxWidth: '80%',
        borderRadius: '14px 14px 4px 14px',
        bgcolor: AIADMIN_PRIMARY_COLOR,
        color: AIADMIN_TEXT_SECONDARY
      }}
    >
      {text}
    </Typography>
    <UserAvatar size={28} />
  </Box>
);

UserMessage.propTypes = { text: PropTypes.string.isRequired };

export default UserMessage;
